import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-suggestion',
  templateUrl: './contact-suggestion.component.html',
  styleUrls: ['./contact-suggestion.component.scss']
})
export class ContactSuggestionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
